export default "__VITE_ASSET__CdQJrBUo__"